import React from 'react';
import { Link } from 'react-router-dom';

// 1. ロゴ画像を '@' を使った絶対パスで import する
import logoImage from '@/src/assets/images/AgLab_logo.png';

// 2. Logoコンポーネントを <img> タグに変更する
const Logo: React.FC = () => (
  <img src={logoImage} alt="AgLab Logo" style={{ width: '120px', height: 'auto' }} />
);

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container mx-auto px-6 py-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="mb-4 md:mb-0">
                <Link to="/">
                    <Logo />
                </Link>
            </div>
            <div className="flex flex-col md:flex-row items-center text-sm text-gray-600">
                 <Link to="/privacy-policy" className="hover:text-[#3aabd2] transition-colors duration-300 md:order-2 md:ml-4">
                    Privacy Policy
                </Link>
                <p className="mt-2 md:mt-0 md:order-1">&copy; 2025 AgLab Co., Ltd. All rights reserved.</p>
            </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;